// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `student-section-sub-header .heading {
  font-weight: 700;
  font-family: Rockwell, Verdana, Arial, sans-serif;
  color: #00375d;
  font-size: 18px;
  padding-left: 0.2em;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/studentui/studentSectionSubHeader.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB","sourcesContent":["student-section-sub-header .heading {\n  font-weight: 700;\n  font-family: Rockwell, Verdana, Arial, sans-serif;\n  color: #00375d;\n  font-size: 18px;\n  padding-left: 0.2em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
